import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FileReaderInput from 'react-file-reader-input';
import {
    Panel, Row, Col, Button
} from 'react-bootstrap';
import {FlircConfigFactory} from './utils';
import FlircConfigHeader from './FlircConfigHeader';
import FlircConfigSettings from './FlircConfigSettings';
import FlircConfigPatterns from './FlircConfigPatterns';

class FlircConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flicConfig: null,
            loadedFileName: null,
            datarows: [],
        };
    }

    fileSelected = (e, results) => {
        this.setState({
            loadedFileName: null,
            datarows: [],
        });
        const d = results[0][0].target.result;
        try {
            this.setState({
                flircConfig: FlircConfigFactory.parse(d),
            });
        } catch (e) {
            this.props.onError(e.message);
            return;
        }

        let rows = [];
        rows.push(
            <Row key="header">
                <Col xs={12}>
                    <FlircConfigHeader flircConfig={this.state.flircConfig} />
                </Col>
            </Row>
        );
        rows.push(
            <Row key="settings">
                <Col xs={12}>
                    <FlircConfigSettings flircConfig={this.state.flircConfig} />
                </Col>
            </Row>
        );
        rows.push(
            <Row key="patterns">
                <Col xs={12}>
                    <FlircConfigPatterns flircConfig={this.state.flircConfig} />
                </Col>
            </Row>
        );

        this.setState({
            datarows: rows,
            loadedFileName: results[0][1].name,
        });
        this.props.onSuccess(results[0][1]);
    };

    render() {
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <Panel header={<h2>Select config</h2>}>
                            <dl className="dl-horizontal">
                                <dt key="1">File loaded:</dt>
                                <dd>{this.state.loadedFileName}</dd>
                            </dl>
                            <FileReaderInput as="buffer" onChange={this.fileSelected}>
                                <Button bsStyle="default">Select file</Button>
                            </FileReaderInput>
                        </Panel>
                    </Col>
                </Row>
                {this.state.datarows}
            </div>
        );
    }
}

FlircConfig.propTypes = {
    onSuccess: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
};

export default FlircConfig;



// WEBPACK FOOTER //
// ./src/FlircConfig.js